import Cookies from '../library/Cookies';

/**
 * Handles the cookie disclaimer bar.
 *
 * @param {HTMLElement} el
 * @param {HTMLElement} acceptButton
 * @param {Cookies} cookies
 */
class CookieConsent {

	/**
	 * Class constructor.
	 */
	constructor() {
		this.el = document.querySelector('.cookies');
		this.acceptButton = document.querySelector('.cookies__accept');
		this.cookies = new Cookies();

		if (this.el) {
			this.accept = this.accept.bind(this);
			this.acceptButton.addEventListener('click', this.accept);
		}
	}

	/**
	 * Adds the 'cookie-bar' class to the body element.
	 *
	 * @return {undefined}
	 */
	show() {
		if (this.el) {
			this.el.classList.remove('hidden');
		}
	}

	/**
	 * Shows the cookie disclaimer if no 'vb_cookie_consent' cookie
	 * has been set.
	 *
	 * @return {undefined}
	 */
	maybeShow() {
		if (!this.cookies.get('vb_cookie_consent')) {
			setTimeout(this.show.apply(this), 1600);
		}
	}

	/**
	 * Removes the 'cookie-bar' class to the body element.
	 *
	 * @return {undefined}
	 */
	hide() {
		if (this.el) {
			this.el.classList.add('hidden');
		}
	}

	/**
	 * Sets the 'vb_cookie_consent' cookie for 1 year and hides the
	 * disclaimer.
	 *
	 * @return {undefined}
	 */
	accept() {
		this.cookies.set('vb_cookie_consent', 1, 365 * 24);
		this.hide();
	}

}

// Create class object
const instance = new CookieConsent();

// Export singleton
export { instance as CookieConsent };
